module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', {
    staticClass: "py-7"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('v-img', {
    attrs: {
      "src": require('@/assets/loading2.gif'),
      "contain": "",
      "height": "150"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold text-center black--text",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n            Sedang Melakukan"), _c('br'), _vm._v("\n            Pengecekan File\n            " + _vm._s(_vm.liveClassTotalCheckRow || 0) + " /\n            " + _vm._s(_vm.liveClassTotal || 0) + "\n        ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ba64723","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class/components/DialogUploadValidation.vue
// module id = 1680
// module chunks = 1